export interface WifiCredentials {
  ssid: string;
  password: string;
}
